import type { ReactNode, ComponentType } from 'react';

interface CardProps {
  title: string;
  icon?: ComponentType<{ size?: number }>;
  children: ReactNode;
  className?: string;
  action?: ReactNode;
}

export const Card = ({ title, icon: Icon, children, className = '', action }: CardProps) => (
  <div className={`bg-gray-800 rounded-lg p-4 ${className}`}>
    <div className="flex items-center justify-between mb-3">
      <div className="flex items-center gap-2 text-gray-300">
        {Icon && <Icon size={18} />}
        <h3 className="font-semibold">{title}</h3>
      </div>
      {action}
    </div>
    {children}
  </div>
);
